import React, { ChangeEvent, useEffect, useState } from "react";
import { fetchLocationsByLesson } from "../../services/ClassesService";
import { notifyError } from "../../services/ToastNotifications";

interface LocationByLessonProps {
  locationId: string;
  handleChange: (newLocation: LocationI) => void;
  lessonId: string;
  id: string;
  userId?: string | null;
}

export interface LocationI {
  id: string;
  name: string;
}

const LocationByLessonSelect = ({
  locationId,
  handleChange,
  lessonId,
  id,
  userId,
}: LocationByLessonProps) => {
  const [locations, setLocations] = useState<LocationI[]>([]);
  const [loadingLocations, setLoadingLocations] = useState<boolean>(true);

  const getLocationsByLesson = async () => {
    try {
      const res = await fetchLocationsByLesson(lessonId, userId || undefined);
      setLocations(res);
    } catch (error) {
      console.error(error);
      notifyError(
        "Hubo un error al cargar las sucursales. Intenta recargar la pagina."
      );
    } finally {
      setLoadingLocations(false);
    }
  };

  const handleLocationSelection = (e: ChangeEvent<HTMLSelectElement>) => {
    const newLocationId = e.target.value;
    const selectedLocation = locations.filter(
      (location) => location.id === newLocationId
    )[0];
    if (selectedLocation) {
      handleChange(selectedLocation);
    }
  };

  useEffect(() => {
    getLocationsByLesson();
  }, [lessonId, userId]);

  if (loadingLocations)
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando sucursales</span>
        </div>
      </div>
    );

  if (locations.length === 0)
    return <h2>No se encontraron sucursales para esta membresia</h2>;

  return (
    <select
      className="form-select fs-18"
      value={locationId}
      aria-label="Selecciona una sucursal"
      onChange={handleLocationSelection}
      id={id}
    >
      <option value={""} disabled>
        Selecciona una sucursal
      </option>
      {locations.map((location) => (
        <option
          value={location.id}
          key={`membership-${id}-location-${location.id}`}
        >
          {location.name}
        </option>
      ))}
    </select>
  );
};

export default LocationByLessonSelect;
